// extracted by mini-css-extract-plugin
module.exports = {"tombstone-loader":"components-Tombstone-TombstoneLoader__tombstone-loader--1CnGs"};